import React, { useEffect, useState } from 'react'
import { images } from 'theme'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment/moment'
import axios from 'axios'
import { Anchorme } from 'react-anchorme'
import { useDispatch, useSelector } from 'react-redux'
import style from './prescription.module.css'
import css from '../consultation/consultation.module.css'
import Link from '../../components/Link/Link'
import { path } from '../../utils/const'
import PopupModal from '../../components/ToggleModal/PopupModal'
import BackComponent from '../../components/BackComponent/BackComponent'
// eslint-disable-next-line import/imports-first
import TransferChatModal from './TransferChatModal/TransferChatModal'
import {actions} from "../../slices/patient.slices";
import { database } from '../../utils/firebase'
import { sendAuthorizedPrescription } from '../../helper/APIHelper'
import { action } from '@storybook/addon-actions'
import qs from 'qs'
import { sendToUserLabAndImaging } from 'pages/labRequisitions/APIS'
import { get } from 'http'
import {checkAllStatuses} from '../../utils/functions'
// eslint-disable-next-line import/imports-first
// eslint-disable-next-line import/imports-first
const url = require('url')

const ReviewPrescriptions = () => {
  const emailUrl = process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL + '/sendFilesWithEmail'
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const [age, setAge] = useState(0)
  const [ageInYear, setAgeInYear] = useState(0)
  const [name, setName] = useState('')
  const [gender, setGender] = useState('')
  const [patientDate, setPatientDate] = useState('')
  const [loadingApprove, setLoadingApprove] = useState(false)
  const [pharmacyData, setPharmacyData] = useState([])
  const [labReq, setlabReq] = useState('')
  const [medicalNoteLink, setMedicalNoteLink] = useState('')
  const [imageReq, setImageReq] = useState('')
  const [prescriptionLinkMail, setPrescriptionLinkMail] = useState('')
  const [healthCardNumber, setHealthCardNumber] = useState('')
  const [adminDoctorEmail, setAdminDoctorEmail] = useState('')
  const [medications, setMedications] = useState([])
  const [openConvo, setOpenConvo] = useState({})
  const [prescriptionLink, setPrescriptionLink] = useState(null)
  const [transferChatModalOpen, setTransferChatModalOpen] = useState(false)
  const archiveId = query.get('archiveId')
  const pathName = query.get('pathName')
  const decline = 'Decline Request'
  const suggestion = 'Suggestion Request'
  const email = useSelector((state) => state.patient.doctorEmail)
  const dispatch = useDispatch()

  const patient = useSelector((state) => state.patient.patientData)
  const archiveData = useSelector((state) => state.patient.archiveData)
  const delegateConvoObj = useSelector((state) => state.patient.delegateData)
  const archiveID = useSelector((state) => state.patient.archiveId)
  let mailReason = '';
  let emailBody =''
  let attachment = ''
  const patientID = useSelector((state) => state.patient.patientID)

  // const {historyLabs,historyMedicalNotes , history_conversations, history_prescriptions} = patient

  const isTransferAllowed =
    delegateConvoObj?.status === 'active' ||
    delegateConvoObj?.status === 'pending'
      ? true
      : false

  const toggleModal = () => {
    setIsOpen((old) => !old)
  }

  const getDataFromFirebase = async (path) => {
    const snapshot = await database.ref(path).once('value');
    return snapshot.val();
  };
  const fetchDelegateData = async (chatID) => {
    let data = await getDataFromFirebase(`/archiveConversations/${chatID}`);
    if (data) {
      return data;
    }
  
    data = await getDataFromFirebase(`/openconversations/${chatID}`);
    if (data) {
      return data;
    }
      data = await getDataFromFirebase(`/delegateChats/${chatID}`);
    if (data) {
      return data;
    }
      console.log('No data found in any path.');
    return null;
  };

  // helper: always return an array of files
const collectAttachments = async () => {
  const out = [];

  if (pathName === 'labNote') {
    if (Array.isArray(labReq) && labReq.length) out.push(...labReq);
    else {
      const one = await tempLabData(archiveID);
      if (one) out.push(one);
    }
  }

  if (pathName === 'imagingNote') {
    if (Array.isArray(imageReq) && imageReq.length) out.push(...imageReq);
    else {
      const one = await tempImageData(archiveID);
      if (one) out.push(one);
    }
  }

  if (pathName === 'medicalNote') {
    if (Array.isArray(medicalNoteLink) && medicalNoteLink.length) out.push(...medicalNoteLink);
  }

  if (pathName === 'prescriptionNote') {
    if (Array.isArray(prescriptionLinkMail) && prescriptionLinkMail.length) out.push(...prescriptionLinkMail);
  }

  return out;
};


  const navigateToConsultation = (archiveID) => {
      const params = new URLSearchParams(window.location.search);
      params.set('archiveId', archiveID);
      navigate(`${path.consultation}?${params.toString()}`, { replace: true });
    };
  // const checkAllStatuses = async (delegateData, delegateConvoObj) => {
  //   const statusMapping = {
  //     labRequisitionData: "labStatus",
  //     imagingData: "imagingStatus",
  //     medicalNotesData: "medicalNoteStatus",
  //     prescriptionData: "prescriptionStatus",
  //   };
  //     const presentDataKeys = Object.keys(statusMapping).filter(
  //     (key) => delegateData[key]
  //   );

  //   if (presentDataKeys.length === 0) {
  //     console.log("No data to track, navigating to pending");
  //     return false;
  //   }
  //     const statuses = presentDataKeys.map((key) => ({
  //     key,
  //     status: delegateConvoObj[statusMapping[key]],
  //   }));
  
  //   console.log("Statuses found:", statuses);
  
  //   const allProcessed = statuses.every(
  //     (item) => item.status === "approved" || item.status === "declined"
  //   );
  
  //   console.log("All processed:", allProcessed);
  
  //   return allProcessed;
  // };

  const navigateToChat = (id) => {
    const chatPath = path.ChatModule
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(chatPath + url.search)
  }
  useEffect(async () => {
    const prescriptionspdf = archiveData?.prescriptionspdf || delegateConvoObj?.prescriptionspdf || null
    if (prescriptionspdf) {
      const parsedUrl = url.parse(prescriptionspdf, true)
      const docId = parsedUrl.query.id
      const previewUrl = `https://drive.google.com/file/d/${docId}/preview?usp=drivesdk`
      const pdfUrl = `${previewUrl}&export?format=pdf`
      setPrescriptionLink(pdfUrl)
    }
    setOpenConvo(archiveData)
    if (archiveData?.prescriptionData) {
      setMedications(
        Object.values(archiveData?.prescriptionData?.medications || {}),
      )
    } else {
      setMedications([])
    }
  }, [archiveData, delegateConvoObj])

  useEffect(async () => {
  
      if (delegateConvoObj?.doctorName ) {
  
        const adminDoctorName = delegateConvoObj?.doctorName.toLowerCase().replace(/\s+/g, '');
        const doctorEmail = await database.ref(`medicalDirective/doctors/${adminDoctorName}/email`).once('value').then((snapshot) => snapshot.val())
         setAdminDoctorEmail(doctorEmail)
      }
    }, [delegateConvoObj])

  useEffect(() => {

    console.log('either run useeeffect')

    if (!archiveID) return;

      if (patient?.historyLabs && archiveID && patient?.historyLabs[archiveID] && (pathName === 'labNote' || pathName === 'imagingNote')) {
        const labReq = patient?.historyLabs[archiveID];
        let labForms = labReq?.labForms || {}; 

        const labLinks = [];
        const imageLinks = [];
    
        if(labForms && Object.keys(labForms).length > 0){

          const formsArray = Object.values(labForms);

          // Filter
          const labFormsArray = formsArray.filter(form => form.fileName?.includes("Lab_Requisition"));
          const imageFormsArray = formsArray.filter(form => form.fileName?.includes("Image_Requisition"));

          if (labFormsArray.length > 0) {
              const latestLab = labFormsArray.reduce((latest, current) =>
                current.timestamp > (latest?.timestamp || 0) ? current : latest,
                null
              );

              if (latestLab) {
                labLinks.push({
                  url: latestLab.file,
                  fileName: `${latestLab.fileName} ${moment(latestLab.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                  type: "application/pdf",
                  timestamp: moment(latestLab.timestamp).format('MM/DD/YYYY, hh:mm A')
                });
              }
           }

            if (imageFormsArray.length > 0) {
                    const latestImage = imageFormsArray.reduce((latest, current) =>
                      current.timestamp > (latest?.timestamp || 0) ? current : latest,
                      null
                    );

                    if (latestImage) {
                      imageLinks.push({
                        url: latestImage.file,
                        fileName: `${latestImage.fileName} ${moment(latestImage.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                        type: "application/pdf",
                        timestamp: moment(latestImage.timestamp).format('MM/DD/YYYY, hh:mm A')
                      });
                    }
               }

          // Object.values(labForms).forEach((form) => {
          //   if (form.fileName.includes("Lab_Requisition")) {
          //     labLinks.push({
          //       url: form.file,
          //       fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
          //       type: "application/pdf",
          //       timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
          //     });
          //   }
          //   if (form.fileName.includes("Image_Requisition")) {
          //     imageLinks.push({
          //       url: form.file,
          //       fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
          //       type: "application/pdf",
          //       timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
          //     });
          //   }
          // });
       }
    
        if (labLinks.length > 0) {
          setlabReq(labLinks);
        }
        if (imageLinks.length > 0) {
          setImageReq(imageLinks);
        }
      }
      

     else if(archiveID && (pathName === 'labNote' || pathName === 'imagingNote')) {

        if(pathName === 'labNote') {
          console.log("Fetching lab notes...");
        // tempLabData(archiveID);
                  const ref = database.ref(`/tempUserNode/userLabResult/${archiveID}/labForms`);
              const listener = snapshot => {
                const labReq = snapshot.val();
                if (labReq) {
                  console.log("Lab notes fetched successfully.", labReq);
                  const formsArray = Object.values(labReq);
                  const latestForm = formsArray.reduce((latest, current) =>
                    current.timestamp > (latest?.timestamp || 0) ? current : latest,
                    null
                  );

                  console.log('latest form:', latestForm);
                  if (latestForm) {
                    const labLink = {
                      url: latestForm.file,
                      fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                      type: 'application/pdf',
                      timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
                    };
                    console.log('Lab link:', labLink);
                    setlabReq([labLink]);
                  }

                }
                  };

            ref.on('value', listener);

            // Optional: clean up listener when unmounting or changing archiveID/pathName
            return () => {
              ref.off('value', listener);
            };
       }
       if(pathName === 'imagingNote') {
        // tempImageData(archiveID);
            const ref = database.ref(`/tempUserNode/userImageResult/${archiveID}/labForms`);
            const listener = snapshot => {
              const imageReq = snapshot.val();
              if (imageReq) {
                const formsArray = Object.values(imageReq);
                const latestForm = formsArray.reduce((latest, current) =>
                  current.timestamp > (latest?.timestamp || 0) ? current : latest,
                  null
                );

                if (latestForm) {
                  const imageLink = {
                    url: latestForm.file,
                    fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                    type: 'application/pdf',
                    timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
                  };
                  setImageReq([imageLink]);
                }
              }
            };

            ref.on('value', listener);

            return () => {
              ref.off('value', listener);
            };
        }
      }
  
      if (archiveID && patient?.historyMedicalNotes && patient?.historyMedicalNotes[archiveID] && pathName === 'medicalNote') {
        const medicalNote = patient?.historyMedicalNotes[archiveID];
        const noteLinks = [];
    
        Object.values(medicalNote.notes).forEach((form) => {
          noteLinks.push({
              url: form.file,
              fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
              type: "application/pdf",
              timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
            });
        });
    
        if (noteLinks.length > 0) {
          setMedicalNoteLink(noteLinks);
        }
      }
      else if(archiveID  && pathName === 'medicalNote') {

         const ref = database.ref(`/tempUserNode/userMedicalNote/${archiveID}/notes`);
          const listener = snapshot => {
            const noteReq = snapshot.val();
            if (noteReq) {
              const formsArray = Object.values(noteReq);
              const latestForm = formsArray.reduce((latest, current) =>
                current.timestamp > (latest?.timestamp || 0) ? current : latest,
                null
              );

              if (latestForm) {
                const noteLink = {
                  url: latestForm.file,
                  fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                  type: 'application/pdf',
                  timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
                };
                setMedicalNoteLink([noteLink]);
              }
            }
          };

          ref.on('value', listener);

          return () => {
            ref.off('value', listener);
          };

        //  tempNoteData(archiveID);
      }
  
      if (archiveID && patient?.history_prescriptions && patient?.history_prescriptions[archiveID] && pathName === 'prescriptionNote') {
        const prescriptionNote = patient?.history_prescriptions[archiveID];
        let prescriptionLinks = [];
        if(prescriptionNote) {
          prescriptionLinks = [{
            url: prescriptionNote?.prescriptionspdf,
            fileName: `prescription${moment(prescriptionNote?.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
            type: "application/pdf",
            timestamp: moment(prescriptionNote?.timestamp).format('MM/DD/YYYY, hh:mm A')
          }];
        
        }
    
        if (prescriptionLinks.length > 0) {
          setPrescriptionLinkMail(prescriptionLinks);
        }
      }
  
    }, [patient, pathName, archiveID, ]);


     const tempLabData = async (archiveID) => {
        try {

          console.log('in temp lab data function')
    
          const labReq = await database.ref(`/tempUserNode/userLabResult/${archiveID}/labForms`).once('value').then((snapshot) => snapshot.val())
          if (labReq) {
            const formsArray = Object.values(labReq);
             const latestForm = formsArray.reduce((latest, current) => {
            return current.timestamp > (latest?.timestamp || 0) ? current : latest;
          }, null);
    
          console.log('latestForm', latestForm)
          if (latestForm) {
             const labLink = {
              url: latestForm.file,
              fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
              type: 'application/pdf',
              timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
            };
            return labLink;
          } 
          }
          }
        catch (error) { 
          console.error('Error fetching lab data:', error);
          return null;
        }
      }

      const tempImageData = async (archiveID) => {
          try {
            const ImageReq = await database.ref(`/tempUserNode/userImageResult/${archiveID}/labForms`).once('value').then((snapshot) => snapshot.val())
            if (ImageReq) {
              const formsArray = Object.values(ImageReq);
               const latestForm = formsArray.reduce((latest, current) => {
              return current.timestamp > (latest?.timestamp || 0) ? current : latest;
            }, null);
      
            if (latestForm) {
               const imageLink = {
                url: latestForm.file,
                fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                type: 'application/pdf',
                timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
              };
              setImageReq([imageLink]);  
            } 
            }
            }
          catch (error) { 
            console.error('Error fetching lab data:', error);
          }
        }

         const tempNoteData = async (archiveID) => {
            try {
        
              const noteReq = await database.ref(`/tempUserNode/userMedicalNote/${archiveID}/notes`).once('value').then((snapshot) => snapshot.val())
              if (noteReq) {
                const formsArray = Object.values(noteReq);
                 const latestForm = formsArray.reduce((latest, current) => {
                return current.timestamp > (latest?.timestamp || 0) ? current : latest;
              }, null);
        
              if (latestForm) {
                 const imageLink = {
                  url: latestForm.file,
                  fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
                  type: 'application/pdf',
                  timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
                };
                setMedicalNoteLink([imageLink]);  
              } 
              }
              }
            catch (error) { 
              console.error('Error fetching lab data:', error);
            }
          }

  useEffect(async () => {
    if (archiveID !== archiveId) {
      dispatch(actions.fetchDelegateData(archiveId))
      dispatch(actions.fetchArchiveOpenData(archiveId))
    }

    if (delegateConvoObj) {
      const date = moment(delegateConvoObj?.DOB, 'MMMM DD YYYY')
      const years = moment().diff(date, 'years')
      setAgeInYear(years)
    }
    if (patient && archiveData) {
      let date = moment(patient?.DOB, 'MMMM,DD,YYYY')
      let years = moment().diff(date, 'years')

      // eslint-disable-next-line no-shadow
      const pharmacyData = patient?.pharmacy || {}
      setPharmacyData(pharmacyData)

      if (
        archiveData?.owner &&
        patient?.profiles &&
        patient?.profiles[archiveData?.owner]
      ) {
        date = moment(patient?.profiles[archiveData?.owner].DOB, 'MMMM,DD,YYYY')

        const convertDate = date.format('MMMM,DD,YYYY')
        setPatientDate(convertDate)

        years = moment().diff(date, 'years')
        setAge(years)
        setName(
          patient?.profiles[archiveData?.owner].name ||
            patient?.profiles[archiveData?.owner].userName ||
            '',
        )
        setGender(patient?.profiles[archiveData?.owner].gender || '')
        setHealthCardNumber(
          patient?.profiles[archiveData?.owner].healthInsuranceCardNumber || '',
        )
      } else {
        date = moment(patient?.DOB, 'MMMM,DD,YYYY')

        const convertDate = date.format('MMMM,DD,YYYY')
        setPatientDate(convertDate)

        years = moment().diff(date, 'years')
        setAge(years)
        setName(patient?.name || patient?.userName || '')
        setGender(patient?.gender || '')
        setHealthCardNumber(patient?.healthInsuranceCardNumber || '')
      }
      if (archiveData?.prescriptionData) {
        setMedications(
          Object.values(archiveData.prescriptionData?.medications || {}),
        )
      } else {
        setMedications([])
      }
    }
  }, [patient, archiveData, delegateConvoObj, archiveID, archiveId])

  const isPatientFromUSA = patient?.country === 'United States'

  const noteStatusKeyMap = {
    prescriptionNote: 'prescriptionStatus',
    medicalNote: 'medicalNoteStatus',
    imagingNote: 'imagingStatus',
    labNote: 'labStatus',
  }
  const noteStatusKey = noteStatusKeyMap[pathName]
  const noteStatus = delegateConvoObj?.[noteStatusKey]
  const isNoteAlreadyActioned = noteStatus === 'approved' || noteStatus === 'declined'
  const isButtonDisabled = isNoteAlreadyActioned || delegateConvoObj?.status !== 'pending'

  const pushUpdatestoFirebase = async (payload) => {
    try {
      const response = await database.ref().update(payload);
      return response?.data || response;
    } catch (e) {
      console.log(e)
    }
  }

  const ChatModule = async () => {
    setLoadingApprove(true)
    try {
      console.log('call chat module from review consult')
        const formattedTime =  moment(delegateConvoObj?.timestamp).format('MM/DD/YYYY, hh:mm A');

      const isAuthRequired = !!Object.values(
        delegateConvoObj?.prescriptionData?.authorization || {},
      ).find((value) => value === 'true')
      const updates = {}
      // updates[`/delegateChats/${delegateConvoObj?.id}/status`] = 'active'
      const prescriptionNodeSnap = await database.ref(`/prescriptionTracking/${delegateConvoObj?.id}`).once('value')
      const prescriptionNodeExists = prescriptionNodeSnap.exists();
      const prescriptionData = prescriptionNodeSnap.val();
      if (isAuthRequired && prescriptionNodeExists && pathName === 'prescriptionNote') {
        console.log('in auth required in review consult')
      updates[`/prescriptionTracking/${delegateConvoObj?.id}/status`] = 'approved'
      updates[`/delegateChats/${delegateConvoObj?.id}/prescriptionStatus`] = 'approved'

      updates[`/prescriptionTracking/${delegateConvoObj?.id}/events/${Date.now()}`] = {
        event: 'approved',
        doctorName: delegateConvoObj?.doctorName
      }
      updates[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/approved`] = {
        doctorName: delegateConvoObj?.doctorName,
        timestamp: Date.now()
      }
      // updates[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/sentToPharmacy`] = null;
      updates[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/declined`] = null;
      // updates[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/received`] = null;
      mailReason = `Prescription Approved - ${delegateConvoObj?.patientName} - ${formattedTime} `
      emailBody = `<html><body>Hi Team,<br><br> A prescription request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been approved by ${delegateConvoObj?.doctorName}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`
      }
       let id = ''
      if(pathName === 'imagingNote' || pathName === 'labNote') {
        if(pathName === 'labNote') {
                id = `${delegateConvoObj?.id}_labs`;
              }
              else if(pathName === 'imagingNote'){
                id = `${delegateConvoObj?.id}_imaging`}
              else{
                id = delegateConvoObj?.id
              }

        const labImaginingNodeSnap = await database.ref(`/labTracking/${id}`).once('value')
       const labImaginingdata = labImaginingNodeSnap.exists();
        const labImaginingData = labImaginingNodeSnap.val();

       if(labImaginingdata){
        console.log('in labImaginingData', labImaginingData)
        if(pathName === 'imagingNote') {

          if(imageReq.length > 0) {
            attachment = imageReq
          }
          else {
            const imagePdf = await tempImageData(archiveID)
            if(imagePdf) {
              console.log('in lab pdf', imagePdf)
              attachment = [imagePdf];
            }
          }
          const payloadData ={
            patientID: delegateConvoObj?.patientID,
            chatID: delegateConvoObj?.id,
            patientName: delegateConvoObj?.patientName,
            type: 'imaging',
            adminDoctor : delegateConvoObj?.doctorName, 
            imageLink: labImaginingData?.link || '',

          } 
            await sendToUserLabAndImaging(
                      qs.stringify(payloadData),
                    )
         updates[`/delegateChats/${delegateConvoObj?.id}/imagingStatus`] = 'approved'
          mailReason = `Imaging requisition Approved - ${delegateConvoObj?.patientName} - ${formattedTime} `
          emailBody = `<html><body>Hi Team,<br><br> A Image request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been approved by ${delegateConvoObj?.doctorName}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`
        }
        if(pathName === 'labNote') 
          {

            console.log('in lab note going to send email')

            const payloadData ={
            patientID: delegateConvoObj?.patientID,
            chatID: delegateConvoObj?.id,
            type: 'lab',
            patientName: delegateConvoObj?.patientName,
            adminDoctor : delegateConvoObj?.doctorName,
            labLink: labImaginingData?.link || '',

          } 
            await sendToUserLabAndImaging(
                      qs.stringify(payloadData),
                    )

            updates[`/delegateChats/${delegateConvoObj?.id}/labStatus`] = 'approved'
             mailReason = `Lab requisition Approved - ${delegateConvoObj?.patientName} - ${formattedTime} `
             emailBody = `<html><body>Hi Team,<br><br> A Lab  request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been approved by ${delegateConvoObj?.doctorName}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`
           console.log('in lab data')
             if(labReq.length > 0) {
              console.log('in lab req')
              attachment = labReq
            }
            else{
              const labPdf = await tempLabData(archiveID)
              if(labPdf) {
                console.log('in lab pdf', labPdf)
                // attachment = labPdf
                 attachment = [labPdf];
              }
            }
         }
        updates[`/labTracking/${id}/status`] = 'approved'
        updates[`/labTracking/${id}/events/${Date.now()}`] = {
          event: 'approved',
          doctorName: delegateConvoObj?.doctorName
        }
        updates[`/labTracking/${id}/userEvents/approved`] = {
          doctorName: delegateConvoObj?.doctorName,
          timestamp: Date.now()
        }
       }
      }
      if(pathName === 'medicalNote') {
        console.log('in medical note')
        if(medicalNoteLink.length > 0) {
          attachment = medicalNoteLink
        }
        else{
         const imagePdf = await tempNoteData(archiveID)
         if(imagePdf) {
           console.log('in image pdf', imagePdf)
           attachment = [imagePdf];
         }
        }
        const medicalNodeSnap = await database.ref(`/medicalNotes/${delegateConvoObj?.id}`).once('value')
        const medicalData = medicalNodeSnap.exists();
        console.log('medicalData', medicalData)
        if(medicalData){
           const payloadData ={
            patientID: delegateConvoObj?.patientID,
            chatID: delegateConvoObj?.id,
            type: 'medicalNote',
            patientName: delegateConvoObj?.patientName,
            adminDoctor : delegateConvoObj?.doctorName,
            labLink: medicalData?.medicalNotePdf || '',

          } 
            await sendToUserLabAndImaging(
                      qs.stringify(payloadData),
                    )

          console.log('in medical data')
        updates[`/delegateChats/${delegateConvoObj?.id}/medicalNoteStatus`] = 'approved'
        updates[`/medicalNotes/${delegateConvoObj?.id}/status`] = 'approved'
        updates[`/medicalNotes/${delegateConvoObj?.id}/events/${Date.now()}`] = {
          event: 'approved',
          doctorName: delegateConvoObj?.doctorName
        }
        updates[`/medicalNotes/${delegateConvoObj?.id}/userEvents/approved`] = {
          doctorName: delegateConvoObj?.doctorName,
          timestamp: Date.now()
        }
        }
        mailReason = `Medical Note Approved - ${delegateConvoObj?.patientName} - ${formattedTime} `;
        emailBody = `<html><body>Hi Team,<br><br> A medical note request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been approved by ${delegateConvoObj?.doctorName}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`;
      }
      if(pathName === 'prescriptionNote' && !isAuthRequired) {

        // update prescription status prescriptionTracking node
        console.log('in no authorize prescription')
        if(prescriptionLinkMail.length > 0) {
          attachment = prescriptionLinkMail
        }
        const prescriptionNodeSnap = await database.ref(`/prescriptionTracking/${delegateConvoObj?.id}`).once('value')
        const prescriptionData = prescriptionNodeSnap.exists();
          if(prescriptionData){
            //need to be remove status
          // updates[`/prescriptionTracking/${delegateConvoObj?.id}/status`] = 'approved'
          // updates[`/prescriptionTracking/${delegateConvoObj?.id}/events/${Date.now()}`] = {
          //   event: 'approved',
          //   doctorName: delegateConvoObj?.doctorName
          // }
          // updates[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/submitted`] = {
          //   doctorName: delegateConvoObj?.doctorName,
          //   timestamp: Date.now()
          // }     

          updates[`/delegateChats/${delegateConvoObj?.id}/prescriptionStatus`] = 'approved'
          
          mailReason = `Prescription Approved - ${delegateConvoObj?.patientName} - ${formattedTime} `
          emailBody = `<html><body>Hi Team,<br><br> A prescription request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been approved by ${delegateConvoObj?.doctorName}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`
        }
    }
      await pushUpdatestoFirebase(updates)
      if (isAuthRequired && prescriptionNodeExists && pathName === 'prescriptionNote')
      {
        console.log('in auth required call sendAuthorizedPrescription function')
        await sendAuthorizedPrescription({ ...delegateConvoObj, country: prescriptionData.country });
      }
      console.log('after call function')

      const payload = {
        'senderEmail': 'no-reply@yourdoctors.online',
        'receiverEmails': (process.env.REACT_APP_ENVIRONMENT === 'staging') ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online', adminDoctorEmail] : ['prescription@yourdoctors.online', adminDoctorEmail],
        'replyToEmail': adminDoctorEmail,
        'subject': `${mailReason} for Chat ID ${delegateConvoObj?.id}`,
        'emailBody': emailBody,
      }
      payload.files = []

      console.log('in email payload', payload)

      console.log('attachment payload', attachment)

         const filesArray = Array.isArray(attachment)
          ? attachment
          : attachment
            ? [attachment]
            : [];

        if (filesArray.length > 0) {
          payload.files = filesArray.map(({ url, fileName, type }) => ({
            url,
            fileName,
            type,
          }));
        }

      // if (attachment && attachment.length > 0) {
      //   payload.files = [
      //     ...attachment.map((file) => ({
      //       url: file.url,
      //       fileName: file.fileName,
      //       type: file.type,
      //     }))
      //   ];
      // }

      console.log('going to call email',payload)
      const resp = await axios.post(emailUrl, payload)

      // check if any thing remain for review than go back consultaion and if no go to active consultation

           const delegateData = await fetchDelegateData(delegateConvoObj?.id);
      
              if (delegateData) {
                  const delegateDataDone = await getDataFromFirebase(`/delegateChats/${delegateConvoObj?.id}`);          
                  const allDone =  await checkAllStatuses(delegateData, delegateDataDone, delegateConvoObj?.id);
                
                  if (allDone) {
                    console.log('All statuses are done');
                    let update = {}
                    console.log('delegateConvoObj?.id', delegateConvoObj?.id)

                     update[`delegateChats/${delegateConvoObj?.id}/status`] = 'active'
                    if(delegateConvoObj?.id) update[`delegateChats/${delegateConvoObj?.id}/medicalNoteTextReason`] = null
                     await database.ref().update(update)
                    navigate(path.activeconsultationpage, { replace: true });
                  } else {
                    console.log('Not all statuses are done');
                    query.set('archiveId', archiveID)
                    navigateToConsultation(archiveID);
                  }
      
              }
      

      setTimeout(() => {
        setLoadingApprove(false)
        toggleModal()
        // navigate(path.activeconsultationpage, { replace: true })
      }, 400)
    } catch (e) {
      setLoadingApprove(false)
      console.log('error', e)
    }
  }
  const navigateToEmail = (decline) => {
    query.set('reason', decline)
    const emailPath = path.sendmail
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(emailPath + url.search)
  }
  return (
    <div /* className={ isOpen? style.overlay:style.root} */>
      <div>
        <BackComponent title="Back" />
        <div className={css.iconAlign}>
          {delegateConvoObj?.conversationID ? (
            <button
              className={css.backgroundsms}
              onClick={(event) => navigateToChat(patientID)}
            >
              <img src={images.chatIcon} className={css.chatIcon} alt="logo" />
            </button>
          ) : (
            <button className={css.backgroundsms}>
              <img
                src={images.disableChat}
                className={css.chatIcon}
                alt="logo"
              />
            </button>
          )}
          <button className={css.backgroundCall}>
            <img src={images.phoneIcon} className={css.chatIcon} alt="logo" />
          </button>
          <button className={css.backgroundCall}>
            <img src={images.videoIcon} className={css.chatIcon} alt="logo" />
          </button>
        </div>

        <div
          className={`${style.patientInformationRoot} ${
            isTransferAllowed ? style.shorter : ''
          }`}
        >
          <div className={css.patientInformation}>
            <span className={css.bold}>Patient</span>
            <span>{delegateConvoObj?.patientName || ''}</span>

            <span className={css.bold}>Issue</span>
            <span>{openConvo?.assessment || archiveData?.assessment}</span>

            <span className={css.bold}>Gender</span>
            <span>{gender}</span>

            <span className={css.bold}>Age</span>

            <span>
              {' '}
              {delegateConvoObj?.DOB || ''} ({ageInYear || ''})
            </span>

            <span className={css.bold}>Encounter Date</span>
            <span>
              {' '}
              {moment(
                new Date(openConvo?.timestamp || archiveData?.timestamp),
              ).format('MM/DD/YY (HH:mm)')}
            </span>

            <span className={css.bold}>Phone number</span>
            <span>{patient?.phone_number}</span>

            <span className={css.bold}>State</span>
            <span>{patient?.state}</span>

            <span className={css.bold}>Health card #</span>
            <span>{healthCardNumber}</span>
          </div>
          <hr className={css.hr} />

          <div className={css.subjective}>
            <span className={css.bold}>Assessment</span>
            <Anchorme target="_blank" className={css.paragraph}>
              {openConvo?.assessment ||
                delegateConvoObj?.assessment ||
                archiveData?.assessment ||
                ''}
            </Anchorme>

            <span className={css.bold}>Plan</span>
            <Anchorme target="_blank" className={css.paragraph}>
              {openConvo?.plan ||
                delegateConvoObj?.plan ||
                archiveData?.plan ||
                ''}
            </Anchorme>

            <>
           {/* Medical Note Section */}
            {pathName === 'medicalNote' && (
              <>
                <span className={css.bold}>Medical Note</span>

                {/* Priority check: openConvo > archiveData > delegateConvoObj */}
                {(() => {
                  const medicalData =
                    openConvo?.medicalNotesData ??
                    archiveData?.medicalNotesData ??
                    delegateConvoObj?.medicalNotesData;

                  if (!medicalData || Object.keys(medicalData).length === 0) {
                    return <p className={css.paragraph}>No Medical Data Available</p>;
                  }

                  // Map over each section dynamically
                  return Object.keys(medicalData).map((key) => {
                    const value = medicalData[key];

                    // If value is an object, loop through its contents
                    if (typeof value === 'object' && value !== null) {
                      return (
                        <div key={key} className={css.labSection}>
                          <span className={css.bold}>
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                          </span>
                          <ul className={css.paragraph}>
                            {Object.values(value).map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      );
                    }

                    // If it's a string and not empty, just display it
                    if (typeof value === 'string' && value.trim() !== '') {
                      return (
                        <div key={key} className={css.labSection}>
                          <span className={css.bold}>
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                          </span>
                          <p className={css.paragraph}>{value}</p>
                        </div>
                      );
                    }

                    return null;
                  });
                })()}
              </>
            )}

            </>

            <>

            {pathName === 'labNote' && (
              <>
              <span className={css.bold}>lab requsition</span>

                {(() => {
                  const labData =
                    openConvo?.labRequisitionData ??
                    archiveData?.labRequisitionData ??
                    delegateConvoObj?.labRequisitionData;

                  if (!labData || Object.keys(labData).length === 0) {
                    return <p className={css.paragraph}>No Lab Data Available</p>;
                  }

                  // Mapping for key transformations
                  const keyMapping = {
                    isScreening: 'Repeat Screening Required?',
                    date: 'Date of Test',
                    gonorrhea: 'Gonorrhea Test',
                    chlamydia: 'Chlamydia Test',
                    other: 'Other Notes',
                    reason: 'Reason for Requisition ',
                    screeningInterval: 'Screening Interval',
                    tests: 'Tests',
                    wound: 'Wound Test',
                  };

                  // Map over each section dynamically
                  return Object.keys(labData).map((key) => {
                    const value = labData[key];
                    const displayName = keyMapping[key] || key.charAt(0).toUpperCase() + key.slice(1);

                    // If value is an object (like biochemistry, hematology, etc.)
                    if (typeof value === 'object' && value !== null) {
                      return (
                        <div key={key} className={css.labSection}>
                          <span className={css.bold}>{displayName}</span>
                          <ul className={css.paragraph}>
                            {Object.values(value).map((test, index) => (
                              <li key={index}>{test}</li>
                            ))}
                          </ul>
                        </div>
                      );
                    }

                    // If it's a string and not empty, just display it
                    if (typeof value === 'string' && value.trim() !== '') {
                      return (
                        <div key={key} className={css.labSection}>
                          <span className={css.bold}>{displayName}</span>
                          <p className={css.paragraph}>{value}</p>
                        </div>
                      );
                    }

                    return null;
                  });
                })()}
              </>
            )}

            </>
            <>
            {/* Imaging Note Section */}
              {pathName === 'imagingNote' && (
                <>
                  <span className={css.bold}>Imaging requisition</span>

                  {/* Priority check: openConvo > archiveData > delegateConvoObj */}
                  {(() => {
                    const imagingData =
                      openConvo?.imagingData ??
                      archiveData?.imagingData ??
                      delegateConvoObj?.imagingData;

                    if (!imagingData || Object.keys(imagingData).length === 0) {
                      return <p className={css.paragraph}>No Imaging Data Available</p>;
                    }

                    // Map over each section dynamically
                    return Object.keys(imagingData).map((key) => {
                      const value = imagingData[key];

                      // If value is an object (like contraindications, contrastRisks, etc.)
                      if (typeof value === 'object' && value !== null) {
                        return (
                          <div key={key} className={css.labSection}>
                            <span className={css.bold}>
                              {key.charAt(0).toUpperCase() + key.slice(1)}
                            </span>
                            <ul className={css.paragraph}>
                              {Object.values(value).map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        );
                      }

                      // If it's a string and not empty, just display it
                      if (typeof value === 'string' && value.trim() !== '') {
                        return (
                          <div key={key} className={css.labSection}>
                            <span className={css.bold}>
                              {key.charAt(0).toUpperCase() + key.slice(1)}
                            </span>
                            <p className={css.paragraph}>{value}</p>
                          </div>
                        );
                      }

                      return null;
                    });
                  })()}
                </>
              )}


            </>

                {pathName === 'prescriptionNote' && (
                <>
                  <span className={css.bold}>Allergies</span>
                  <p className={css.paragraph}>
                    {openConvo?.prescriptionData?.allergies ??
                      archiveData?.prescriptionData?.allergies ??
                      delegateConvoObj?.prescriptionData?.allergies ??
                      '-'}
                  </p>

                  <span className={css.bold}>Known medical condition</span>
                  <p className={css.paragraph}>
                    {openConvo?.prescriptionData?.medicalConditions ??
                      archiveData?.prescriptionData?.medicalConditions ??
                      delegateConvoObj?.prescriptionData?.medicalConditions ??
                      '-'}
                  </p>

                  <span className={css.bold}>Current medications</span>
                  <p className={css.paragraph}>
                    {openConvo?.prescriptionData?.previousMedications ??
                      archiveData?.prescriptionData?.previousMedications ??
                      delegateConvoObj?.prescriptionData?.previousMedications ??
                      '-'}
                  </p>

                  <span className={css.bold}>Prescription</span>
                  <p className={css.paragraph}>
                    {openConvo?.prescriptionData?.medicationNames ??
                      archiveData?.prescriptionData?.medicationNames ??
                      delegateConvoObj?.prescriptionData?.medicationNames ??
                      ''}
                  </p>

                  <span className={css.bold}>Pharmacy details</span>
                  <div className={style.pharmacyDetail}>
                    <div className={style.row}>
                      <span className={css.bold}>Address:</span>
                      <span className={style.fontsize}>
                        {pharmacyData?.address ?? delegateConvoObj?.pharmacy?.address ?? '-'}
                      </span>
                    </div>
                    <div className={style.row}>
                      <span className={css.bold}>Fax number:</span>
                      <span className={style.fontsize}>
                        {pharmacyData?.fax_number ?? delegateConvoObj?.pharmacy?.fax_number ?? '-'}
                      </span>
                    </div>
                    <div className={style.row}>
                      <span className={css.bold}>Name:</span>
                      <span className={style.fontsize}>
                        {pharmacyData?.name ?? delegateConvoObj?.pharmacy?.name ?? '-'}
                      </span>
                    </div>
                    <div className={style.row}>
                      <span className={css.bold}>Phone number:</span>
                      <span className={style.fontsize}>
                        {pharmacyData?.phone_number ?? delegateConvoObj?.pharmacy?.phone_number ?? '-'}
                      </span>
                    </div>
                  </div>
                </>
              )}

{/* 
            <span className={css.bold}>Allergies</span>
            <p className={css.paragraph}>
              {openConvo?.prescriptionData?.allergies ||
                archiveData?.prescriptionData?.allergies ||
                delegateConvoObj?.prescriptionData?.allergies ||
                '-'}
            </p>

            <span className={css.bold}>Known medical condition</span>
            <p className={css.paragraph}>
              {openConvo?.prescriptionData?.medicalCondition ||
                archiveData?.prescriptionData?.medicalCondition ||
                delegateConvoObj?.prescriptionData?.medicalCondition ||
                '-'}
            </p>

            <span className={css.bold}>Current medications</span>
            <p className={css.paragraph}>
              {openConvo?.prescriptionData?.previousMedications ||
                archiveData?.prescriptionData?.previousMedications ||
                delegateConvoObj?.prescriptionData?.previousMedications ||
                '-'}
            </p>

            <span className={css.bold}>Prescription</span>
            <p className={css.paragraph}>
              {openConvo?.prescriptionData?.medicationNames ||
                archiveData?.prescriptionData?.medicationNames ||
                delegateConvoObj?.prescriptionData?.medicationNames ||
                ''}
            </p>

            <span className={css.bold}>Pharmacy details</span>
            <div className={style.pharmacyDetail}>
              <div className={style.row}>
                <span className={css.bold}>Address:</span>
                <span className={style.fontsize}>
                  {pharmacyData?.address || delegateConvoObj?.pharmacy?.address}
                </span>
              </div>
              <div className={style.row}>
                <span className={css.bold}>Fax number:</span>
                <span className={style.fontsize}>
                  {pharmacyData?.fax_number ||
                    delegateConvoObj?.pharmacy?.fax_number}
                </span>
              </div>

              <div className={style.row}>
                <span className={css.bold}>Name:</span>
                <span className={style.fontsize}>
                  {pharmacyData?.name || delegateConvoObj?.pharmacy?.name}
                </span>
              </div>

              <div className={style.row}>
                <span className={css.bold}>Phone number:</span>
                <span className={style.fontsize}>
                  {pharmacyData?.phone_number ||
                    delegateConvoObj?.pharmacy?.phone_number}
                </span>
              </div>
            </div>
            */}
          </div>
        </div>
        <div className={css.buttonDiv}>
          <Link href={prescriptionLink || '#'} target="_blank">
            <button
            disabled={pathName === 'imagingNote' || pathName === 'labNote' || pathName === 'medicalNote'}
              className={
                prescriptionLink ? style.buttonStyle : style.disableButton
              }
            >
              View PDF
            </button>
          </Link>
          <button
            className={isButtonDisabled ? style.disableButton : css.buttonStyle}
            onClick={() => {
              if (!isButtonDisabled) toggleModal()
            }}
          >
            Approve
          </button>

          {isOpen && (
            <PopupModal
              openConvo={openConvo}
              approve="Approve consultation"
              content="Upon approval, a message will be sent to the patient to establish a patient-doctor relationship."
              delegateConvoObj={delegateConvoObj}
              patientData={patientID}
              loading={loadingApprove}
              handleClick={ChatModule}
              toggleModal={toggleModal}
            />
          )}
          <button
            className={isButtonDisabled ? style.disableButton : css.buttonStyle}
            onClick={(event) => {
              if (!isButtonDisabled) navigateToEmail(decline)
            }}
          >
            Decline
          </button>

          <button
            className={isButtonDisabled ? style.disableButton : css.buttonStyle}
            onClick={(event) => {
              if (!isButtonDisabled) navigateToEmail(suggestion)
            }}
          >
            Suggest Edits
          </button>
          {isTransferAllowed && (
            <button
              className={css.transferBtn}
              onClick={() => setTransferChatModalOpen((c) => !c)}
              disabled={!isPatientFromUSA}
            >
              Transfer Chat
            </button>
          )}
        </div>
      </div>

      {/* Modals */}

      {transferChatModalOpen && (
        <TransferChatModal
          isOpen={transferChatModalOpen}
          closeModal={() => setTransferChatModalOpen((c) => !c)}
        />
      )}
    </div>
  )
}

export default ReviewPrescriptions
